import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  accept() {
    const d = new Date()
    d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000)
    document.cookie = "cookie-consent=true;expires=" + d.toUTCString() + ";path=/"
    this.element.remove()
  }
}
